import React from "react";
import classNames from "classnames";
import { BemHelper } from "@/utils/BemHelper";
import { currencyFormat, useBreakpointValue } from "@/utils/index";
import defaultImage from "./images/default-course.jpeg";
import { Col, Row, Typography } from "antd";
import { LessonIcon } from "@/icons/primary/lesson-icon";
import { CaButton } from "src/admin-panel";

type Props = {
  title: string;
  price: number | string;
  image?: string;
  avatar?: string;
  fullName?: string;
  lessonsCounter?: number;
  hidePrice?: boolean;
  onClick?: () => void;
  onImageClick?: () => void;
  disabled?: boolean;
  toCreator?: () => void;
};

const bem = new BemHelper("course-card");

export const CourseCard: React.FC<Props> = ({
  title,
  price,
  image,
  avatar,
  fullName,
  lessonsCounter,
  hidePrice,
  onClick,
  onImageClick,
  disabled = false,
  toCreator,
}) => {
  const isMobile = useBreakpointValue({ base: false, xs: true });

  return (
    <div className={classNames(bem.block())}>
      <div
        className={classNames(
          bem.element("image"),
          isMobile && bem.element("image-mobile"),
          onImageClick && bem.modifier("has-actions"),
          disabled && parseFloat(price.toString()) !== 0 && bem.element("disabled"),
        )}
        onClick={() => onImageClick && onImageClick()}
      >
        <img src={image || defaultImage} />
      </div>
      <div
        className={classNames(
          bem.element("content"),
          isMobile && bem.modifier("mobile-content"),
          disabled && parseFloat(price.toString()) !== 0 && bem.element("disabled"),
        )}
      >
        {/* Title */}
        <Row>
          <Col>
            <Typography.Paragraph
              className={classNames(
                bem.element("title"),
                isMobile && bem.modifier("mobile", "title"),
                onClick && bem.modifier("has-actions"),
              )}
              ellipsis={{ rows: 2, expandable: false, symbol: "..." }}
              style={{ marginBottom: 0 }}
            >
              {title}
            </Typography.Paragraph>
          </Col>
        </Row>

        {/* Price */}
        <div className={classNames(bem.element("header"))}>
          {!hidePrice && (
            <div className={classNames(bem.element("price"))}>
              {parseFloat(price.toString()) !== 0 ? currencyFormat(price) : "FREE"}
            </div>
          )}
        </div>

        <Row style={{ marginTop: 15 }}>
          {/* User avatat and name */}
          <Row
            onClick={() => {
              toCreator && toCreator();
            }}
            style={{ cursor: toCreator ? "pointer" : "auto" }}
          >
            {avatar && (
              <div
                className={classNames(bem.element("avatar-user"))}
                style={{ background: `url('${avatar}') no-repeat` }}
              />
            )}
            {fullName && <div className={classNames(bem.element("full-name"))}>{fullName}</div>}
          </Row>

          {/* Lessons */}

          <Row style={{ marginLeft: 20 }}>
            <LessonIcon />
            <div className={classNames(bem.element("lesson-counter"))}>{`${lessonsCounter} Lesson${
              lessonsCounter && lessonsCounter > 0 ? "s" : ""
            }`}</div>
          </Row>
        </Row>

        <Row style={{ marginTop: 15 }}>
          <CaButton
            size='small'
            intent='secondary'
            type='button'
            onClick={onClick}
            disabled={lessonsCounter === 0}
          >
            VIEW
          </CaButton>
        </Row>
      </div>
    </div>
  );
};
